import { render, staticRenderFns } from "./TrackingProducts.vue?vue&type=template&id=40fba796&scoped=true&"
import script from "./TrackingProducts.vue?vue&type=script&lang=js&"
export * from "./TrackingProducts.vue?vue&type=script&lang=js&"
import style0 from "./TrackingProducts.vue?vue&type=style&index=0&id=40fba796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fba796",
  null
  
)

export default component.exports